const storyMap = {
  selectProject: "Выбрать проект",
  noProjects: "Нет проектов",
  addEpic: "Добавить эпик",
  addStory: "Добавить историю",
  editCard: "Редактировать карточку",
  deleteCard: "Удалить карточку",
  deleteColumn: "Удалить столбец",
  deleteColumnConfirm: "Удалить столбец и все его карточки?",
  epicPlaceholder: "Название эпика...",
  storyPlaceholder: "Название истории...",
  subStories: "Подистории",
  addSub: "Добавить подисторию",
  subPlaceholder: "Подистория...",
  emptyBoard: "Доска пуста — добавьте первый эпик",
  demoMode: "Демо-режим",
  demoModeHint: "Демо-данные — нет подключения к Supabase. Данные не настоящие.",
  colorPicker: "Цвет",
  noColor: "Без цвета",
  cardCount: "карточек",
  addFeature: "Добавить фичу",
  featurePlaceholder: "Название фичи...",
  realtimeConnected: "Подключено",
  realtimeConnecting: "Подключение...",
  realtimeDisconnected: "Отключено",
  notes: "Заметки",
  addNote: "Добавить заметку",
  notePlaceholder: "Заметки, критерии, ссылки...",
  diagram: "Диаграмма",
  editDiagram: "Редактировать диаграмму",
  diagramPlaceholder: "graph TD\n  A-->B",
  preview: "Предпросмотр",
  save: "Сохранить",
  filterSearch: "Поиск карточек...",
  clearFilters: "Очистить фильтры",
  epic: "Эпик",
  feature: "Фича",
  story: "История",
  statsEpics: "Эпики",
  statsFeatures: "Фичи",
  statsStories: "Истории",
  statsCompletion: "Завершение подисторий",
  statsTotal: "Всего карточек",
  estimation: "Оценка",
  noEstimation: "Без оценки",
  totalPoints: "Всего очков",
  export: "Экспорт",
  exportJSON: "Экспорт JSON",
  exportMarkdown: "Экспорт Markdown",
  exportPNG: "Экспорт PNG",
  exporting: "Экспорт...",
  openInEditor: "Открыть в редакторе",
  createNote: "Создание заметки...",
  hasNote: "Есть связанная заметка",
  linkEntity: "Связать сущность",
  linkedEntities: "Связанные сущности",
  searchEntity: "Найти сущность для связи...",
  unlinkEntity: "Отвязать",
  noLinkedEntities: "Нет связанных сущностей",
  defaultEpic: "Эпик",
  defaultFeature: "Новая фича",
  defaultStory: "Новая история",
} as const;
export default storyMap;
